import { API_URL, ONLINE_SALES_TEAM_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${ONLINE_SALES_TEAM_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchOnlineSalesTeam = async (lang: string) => {
  try {
    const onlineSalesTeamResponse = await fetchWithAuth(
      `${API_URL}/online-sales-team?populate=Banner.BannerImage,Banner.BannerImageTab,Banner.BannerImageMob,Members.FeaturedImage,GA,SEO.MetaImage&pagination[limit]=-1`,
      lang
    );

    const onlineSalesTeam = onlineSalesTeamResponse.data;

    console.log('fetchOnlineSalesTeam API Response:', onlineSalesTeam);
    return onlineSalesTeam;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};